/**
 * RouteFallback — royal-themed Suspense fallback shown while a lazy route
 * chunk is being fetched.
 *
 * Phase W (perf):
 *   • Replaces blank-screen flashes when routes are code-split via React.lazy.
 *   • Uses the same deep-purple base as the page background so the transition
 *     is calm, not jarring.
 *   • Minimal DOM (no heavy stars, no animations) for lowest paint cost.
 */
import LodestarMark from "@/components/LodestarMark";

export default function RouteFallback() {
    return (
        <div
            data-testid="route-fallback"
            className="min-h-[80vh] grid place-items-center"
            style={{ background: "#12051F" }}
        >
            <div className="flex flex-col items-center gap-4">
                <div className="opacity-80">
                    <LodestarMark size={64} showHalo={false} />
                </div>
                <div className="text-[10px] font-sans uppercase tracking-[0.36em] text-lodestar-gold-champagne/70">
                    Aligning the sky
                </div>
                <div className="h-[2px] w-32 rounded-full overflow-hidden bg-lodestar-imperial/40">
                    <div className="h-full w-1/2 bg-gradient-to-r from-transparent via-lodestar-gold-soft to-transparent animate-pulse" />
                </div>
            </div>
        </div>
    );
}
